<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M7.333 27.333h17.333v-16H21.65A3.667 3.667 0 0118 7.666v-3H7.333v22.667zm14.586-19.92l1.919 1.92h-2.182A1.667 1.667 0 0120 7.666V5.494l1.919 1.92zM6.999 2.667c-.92 0-1.666.746-1.666 1.667v23.333c0 .92.746 1.667 1.667 1.667h18c.92 0 1.666-.746 1.666-1.667V10.023c0-.442-.175-.866-.488-1.178l-2.845-2.846-2.845-2.845a1.667 1.667 0 00-1.179-.488H7zm5.294 12.96a1 1 0 011.414 0L16 17.919l2.293-2.293a1 1 0 011.414 1.414l-2.293 2.293 2.293 2.293a1 1 0 01-1.414 1.414L16 20.747l-2.293 2.293a1 1 0 01-1.414-1.414l2.293-2.293-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'filesCloseOutline'
}
</script>
